import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EffectsModule, provideEffects} from '@ngrx/effects';
import {DEFAULT_ROUTER_FEATURENAME, MinimalRouterStateSerializer, NavigationActionTiming, routerReducer, RouterState, StoreRouterConnectingModule} from '@ngrx/router-store';
import {provideStore, StoreModule} from '@ngrx/store';
import {provideStoreDevtools, StoreDevtoolsModule} from '@ngrx/store-devtools';
import {environment} from '../../environments/environment';
import {AutoSaveEffects} from './auto-save/auto-save.effects';
import {autoSaveReducer} from './auto-save/auto-save.reducer';
import {MasterDataStoreEffects} from './master-data-store/master-data-store.effects';
import masterDataStoreReducer, {masterDataStoreFeatureKey} from './master-data-store/master-data-store.reducer';
import {NotificationEffects} from './notification/notification.effects';
import {notificationReducer} from './notification/notification.reducer';
import {pagingReducer} from './paging/paging.reducer';

const rootReducers = {
  autoSave: autoSaveReducer,
  notification: notificationReducer,
  paging: pagingReducer,
  [DEFAULT_ROUTER_FEATURENAME]: routerReducer
};

const storeConfig = {
  runtimeChecks: {
    strictStateImmutability: true,
    strictActionImmutability: true,
    strictStateSerializability: true,
    strictActionSerializability: true
  }
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(rootReducers, storeConfig),
    EffectsModule.forRoot([AutoSaveEffects, NotificationEffects]),
    StoreModule.forFeature(masterDataStoreFeatureKey, masterDataStoreReducer),
    EffectsModule.forFeature([MasterDataStoreEffects]),
    StoreRouterConnectingModule.forRoot({
      serializer: MinimalRouterStateSerializer,
      navigationActionTiming: NavigationActionTiming.PostActivation,
      routerState: RouterState.Minimal
    }),
    !environment.production ? StoreDevtoolsModule.instrument({autoPause: true, connectInZone: false}) : []
  ],
  providers: [
    provideStore(rootReducers, storeConfig),
    provideEffects([AutoSaveEffects, NotificationEffects]),
    !environment.production ? provideStoreDevtools({autoPause: true, connectInZone: false}) : []
  ]
})
export class RootStoreModule {}
